export default {
  name: 'emergency-manage',
  path: 'emergency-manage',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '应急管理',
    redirect: true,
    hideSubMenu: true,
    icon: 'icon-a-jianqu17'
  },
  children: [
    {
      name: 'emergency-resource',
      path: 'emergency-resource',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '应急资源管理', redirect: true, icon: 'icon-usergroup'},
      children: [
        {
          name: 'emergency-organization',
          path: 'emergency-organization',
          component: () => import(
            '@/views/emergency-manage/emergency-resource/emergency-organization/EmergencyOrganization.vue'),
          meta: {
            title: '应急组织机构'
          }
        },
        {
          name: 'materials-equipment',
          path: 'materials-equipment',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '物资装备管理', redirect: true, menuChildren: true
          },
          children: [
            {
              name: 'inventory-manage',
              path: '',
              component: () => import(
                '@/views/emergency-manage/emergency-resource/materials-equipment/MaterialsEquipment.vue'),
              meta: {
                title: '物资装备管理列表',
              }
            },
            {
              name: 'allocation-materials',
              path: 'allocation-materials',
              component: () => import(
                '@/views/emergency-manage/emergency-resource/materials-equipment/inventory-manage/AllocationMaterials.vue'),
              meta: {
                title: '物资调拨',
                noLimits: true
              }
            },
            {
              name: 'material-outbound',
              path: 'material-outbound',
              component: () => import(
                '@/views/emergency-manage/emergency-resource/materials-equipment/inventory-manage/MaterialOutbound.vue'),
              meta: {
                title: '物资出库',
                noLimits: true
              }
            },
            {
              name: 'material-inbound',
              path: 'material-inbound',
              component: () => import(
                '@/views/emergency-manage/emergency-resource/materials-equipment/inventory-manage/MaterialInbound.vue'),
              meta: {
                title: '物资入库',
                noLimits: true
              }
            },
          ]
        },
        {
          name: 'rescue-team',
          path: 'rescue-team',
          component: () => import(
            '@/views/emergency-manage/emergency-resource/rescue-team/RescueTeam.vue'),
          meta: {
            title: '应急救援队伍'
          }
        },
        {
          name: 'emergency-specialist',
          path: 'emergency-specialist',
          component: () => import(
            '@/views/emergency-manage/emergency-resource/emergency-specialist/EmergencySpecialist.vue'),
          meta: {
            title: '应急专家'
          }
        },
        {
          name: 'emergency-shelter',
          path: 'emergency-shelter',
          component: () => import(
            '@/views/emergency-manage/emergency-resource/emergency-shelter/EmergencyShelter.vue'),
          meta: {
            title: '应急避难场所'
          }
        },
      ]
    },
    {
      name: 'emergency-warehouse',
      path: 'emergency-warehouse',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '应急仓库管理', redirect: true, icon: 'icon-usergroup'},
      children: [
        {
          name: 'location-manage',
          path: 'location-manage',
          component: () => import(
            '@/views/emergency-manage/emergency-warehouse/location-manage/LocationManage.vue'),
          meta: {
            title: '存放地点管理'
          }
        },
        {
          name: 'material-info',
          path: 'material-info',
          component: () => import(
            '@/views/emergency-manage/emergency-warehouse/material-info/MaterialInfo.vue'),
          meta: {
            title: '物资信息管理'
          }
        },
      ]
    },
    {
      name: 'plan-management',
      path: 'plan-management',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '应急预案管理', redirect: true, menuChildren: true},
      children: [
        {
          name: 'plan-management-list',
          path: '',
          component: () => import('@/views/emergency-manage/plan-management/PlanManagement.vue'),
          meta: {title: '应急预案管理'}
        }, {
          name: 'plan-management-details',
          path: 'detail',
          component: () => import('@/views/emergency-manage/plan-management/PlanManageDetails.vue'),
          meta: {title: '应急预案详情'}
        }
      ]
    },
    {
      name: 'plan-organization',
      path: 'plan-organization',
      component: () => import('@/views/emergency-manage/plan-organization/PlanOrganization.vue'),
      meta: {title: '应急预案编制'},
    },
    {
      name: 'emergency-drill',
      path: 'emergency-drill',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '应急演练管理', redirect: true, icon: 'icon-yingjiyanliantixing'},
      children: [
        {
          name: 'drill-plan',
          path: 'drill-plan',
          component: () => import('@/views/emergency-manage/emergency-drill/drill-plan/DrillPlan.vue'),
          meta: {title: '应急演练计划'},
        },
        {
          name: 'drill-records',
          path: 'drill-records',
          component: () => import('@/views/emergency-manage/emergency-drill/drill-records/DrillRecords.vue'),
          meta: {title: '应急演练记录'},
        },
      ]
    },
    {
      name: 'accident-management',
      path: 'accident-management',
      component: () => import('@/views/emergency-manage/accident-management/AccidentManagement.vue'),
      meta: {title: '事故管理', icon: 'icon-zuguanli'},
    },
  ]
}